export default __webpack_public_path__ + "static/media/camera.51c9d6d9.svg";